<div class="moorl-listing-config">
    <moorl-form
        v-if="!isLoading"
        :item="value"
        componentName="moorl-listing-config"
        :mapping="cmsElementMapping"
        pathAppend="value"
    />
</div>
